import { authLocalStorage, urlSessionStorage } from '@/lib/storage';
import { Navigate } from 'react-router-dom';

export default function StartPage() {
  const beForeUrl = urlSessionStorage().url;
  const auth = authLocalStorage().auth;

  if (beForeUrl !== '/signInSns' && auth) {
    return <Navigate to="/wallet" />;
  }
  return (
    <>
      <Navigate to="/signInSns" />
    </>
  );
}
